import React from "react";
import styled from "styled-components";

const MainContentWrapper = styled.main`
    /* flex: 1 0 auto; */
    flex-grow: 1;
`;

export default MainContentWrapper;
